export default __webpack_public_path__ + "static/media/Gpa_Power_Credit.da88a3de.jpeg";